import { render } from "./newsession.vue?vue&type=template&id=f6700350&scoped=true"
import script from "./newsession.vue?vue&type=script&lang=js"
export * from "./newsession.vue?vue&type=script&lang=js"

import "./newsession.vue?vue&type=style&index=0&id=f6700350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6700350"]])

export default __exports__